import axios from "axios";

// Header que o HAProxy usa para mandar a requisicao a uma versao especifica da API
// (ex.: "lv13" = VPS Laravel 13 com Reverb). Vazio = roteamento padrao.
export const backendRouteHeaders = process.env.VUE_APP_BACKEND_ROUTE
    ? {'X-R2-Backend': process.env.VUE_APP_BACKEND_ROUTE}
    : {}

export const http = axios.create({
    baseURL: process.env.VUE_APP_BACK_END,
    headers: backendRouteHeaders
})

export const httpCustom = axios.create({
    baseURL: process.env.VUE_APP_BACK_END,
    headers: backendRouteHeaders
})

export const httpAuth = axios.create({
    baseURL: process.env.VUE_APP_URL_AUTH
})
